import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';

@Injectable({
  providedIn: 'root',
})
export class ChildApiService {
  constructor(private http: HttpClient,private downloadHelper: downloadHelper) {}
  search( ev: any = []) {
    return lastValueFrom(
      this.http.post(`/child/search`, ev)
    );
  }

  saveDetails(data: any) {
    return lastValueFrom(this.http.post(`/child/save`, data));
  }
  getParentSearch(data: any) {
    return lastValueFrom(this.http.post(`/child/getParentSearch`, data));
  }
  getList(ev: any,active=true) {
    const type = active ? 'ACTIVE' : 'INACTIVE';
    return lastValueFrom(this.http.post(`/child/getList/${type}`, ev));
  }
  getListBySponsor(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`/child/getListBySponsor${lasyP}`));
  }

  download(id: any,tempName: string = 'profile', data: any = {}) {
    const url = `/child/download/${id}/${tempName}`;
    const fileName = `${data.name || ''}-${data.child_id || ''}` || '';
    return this.downloadHelper.downloadApi(url, 'GET', fileName);
  }
 
  pendingEducation(type: string, ev: any) {
    return lastValueFrom(this.http.post(`/child/pendingEducation/${type}`, ev));
  }
  pendingYearlyPending(ev: any) {
    return lastValueFrom(this.http.post(`childYearlyReport/getPendingList`, ev));
  }
  getChildYearlyList(ev: any) {
    return lastValueFrom(this.http.post(`childYearlyReport/getList`, ev));
  }
   sentEmailYearlyReport(id: string| number) {
    return lastValueFrom(this.http.post(`childYearlyReport/emailSent/${id}`,{}));
  }
  pendingEduByChild(type: string, cid: any) {
    return lastValueFrom(
      this.http.get(`/child/pendingEduByChild/${type}/${cid}`)
    );
  }
  approveYearlyReport(data: any) {
    return lastValueFrom(this.http.post(`/childYearlyReport/save`, data));
  }
   getYearlyReport(id: any) {
    return lastValueFrom(this.http.get(`/childYearlyReport/get/${id}`));
  }
  rejectEdu(data: any) {
    return lastValueFrom(this.http.post(`/child/rejectEdu`, data));
  }
  getDetail(id: any) {
    return lastValueFrom(this.http.get(`/child/getDetail/${id}`));
  }
  getSibling(id: any) {
    return lastValueFrom(this.http.get(`/child/getSibling/${id}`));
  }

  getBasic(id: any, isFull = false) {
    return lastValueFrom(this.http.get(`/child/getBasic/${id}/${isFull}`));
  }

  relive(id: any, data: any) {
    return lastValueFrom(this.http.post(`/child/relive/${id}`, data));
  }
  
  getReportById(id: any) {
    return lastValueFrom(this.http.get(`/child/getReportById/${id}`));
  }
  saveReport(data: any) {
    return lastValueFrom(this.http.post(`/child/saveReport`, data));
  }
  deleteReport(id: any) {
    return lastValueFrom(this.http.delete(`/child/delete/${id}`));
  }
  // home

  getHomeDetail(id: any) {
    return lastValueFrom(this.http.get(`/home/getDetail/${id}`));
  }

  checkRequestExists = (data: any): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      console.log(data);
      if (+(data.modify_request || 0) == 1) {
        resolve(false);
        return;
      }
      this.getBasic(data.child_id)
        .then((res: ResponseData | any) => {
          if (res.statusCode == RESPONSE_CODE.SUCCESS) {
            if (res.result) {
              if (+res.result.modify_request == 0) {
                resolve(true);
              }
            }
          }
          resolve(false);
        })
        .catch((err) => {
          reject(true);
        });
    });
  };
}
